document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.header-menu__item');
  let hideTimeout;

  menuItems.forEach(item => {
    const submenu = item.querySelector('.header-menu__submenu');
    
    if (submenu) {
      item.addEventListener('mouseenter', function() {
        clearTimeout(hideTimeout);
        submenu.style.display = 'block';
      });

      item.addEventListener('mouseleave', function() {
        hideTimeout = setTimeout(function() {
          submenu.style.display = 'none';
        }, 650); // 650ms delay
      });

      submenu.addEventListener('mouseenter', function() {
        clearTimeout(hideTimeout);
      });

      submenu.addEventListener('mouseleave', function() {
        hideTimeout = setTimeout(function() {
          submenu.style.display = 'none';
        }, 650);
      });
    }
  });
});
